export default __webpack_public_path__ + "99f2b1affc6bc401067a842b1393c2ff.png";